/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import Formsy from 'formsy-react';

import GoogleSSO from './GoogleSSO';
import withAuth from '../utils/withAuth';
import postUserWebLoginForm from '../api/graphql/mutations/postUserWebLoginForm';

// import { UserProfileContextConsumer } from '../context/userProfileContext';

import FormInputLogin from './Form/FormInputLogin';
import LoadIcon from './LoadIcon';

class UserWebLoginForm extends Component {
  state = {
    canSubmit: false,
    isLoading: true,
  };

  componentDidMount() {
    const { getToken, history } = this.props;
    const token = getToken();
    if (token) {
      history.push('/cms');
    } else {
      this.setState({ isLoading: false });
    }
  }

  submitForm = (formData, resetForm, invalidateForm) => {
    const { history, setToken, setUserToLocalStorage } = this.props;

    this.setState({ canSubmit: false });

    postUserWebLoginForm({ ...formData }).then((response) => {
      if (!response || !response.token || response.token === 'notFoundOrWrongPassword') return invalidateForm({ password: 'Invalid user or password' });
      if (response.token === 'notActive') return invalidateForm({ email: 'This account has not been activated yet!' });

      const token = setToken(response.token);

      if (!token) return invalidateForm({ email: 'invalid user' });

      setUserToLocalStorage(response.token);
      this.onReset();
      history.push('/cms');
      return undefined;
    });
  };

  // form.reset() is enough on its own. It calls resetValue() on every attached input,
  // which restores each to its pristine value - '' for both of these. The two explicit
  // setValue('') calls that used to follow relied on `ref` landing on the withFormsy
  // wrapper; in formsy-react 2 withFormsy returns a function component, so those refs are
  // null and the calls would throw.
  onReset = () => {
    this.form.reset();
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  render() {
    const { canSubmit, isLoading } = this.state;
    return (
    // <UserProfileContextConsumer>
    //   {({ loadTokenForLS }) => (
      <>
        {!isLoading
          ? (
            <div className="w-1/3 md:w-1/2 sm:w-full mx-auto font-americaMonoRegular flex flex-col justify-center">
              <div className="my-8">Login with Google</div>
              <GoogleSSO />
              <div className="mt-4 w-full text-center">-----------------</div>
              <div className="my-8">Or login with email and password</div>
              <Formsy ref={(c) => { this.form = c; return this.form; }} onValidSubmit={this.submitForm} onValid={this.enableButton} onInvalid={this.disableButton} className="flex sm:flex-col md:flex-col flex-wrap">
                <FormInputLogin name="email" title="Email" validations={{ isEmail: true, maxLength: 50 }} validationErrors={{ isEmail: 'This is not a valid email', maxLength: 'The email is too long' }} required />
                <FormInputLogin name="password" title="Password" type="password" validations="minLength:5" validationError="The password is too short" required />
                <div className="flex justify-between w-full ">
                  {/* <div className="flex flex-col justify-center w-3/4 sm:w-full">
                    <Link to="/account/recover" className="text-black underline font-americaMonoBold mx-4 block">Forgot Password</Link>
                  </div> */}
                  <div className="flex flex-col w-1/2 sm:w-full">
                    <button type="submit" disabled={!canSubmit} className={`${canSubmit ? 'bg-black' : 'bg-grey'} h-12 text-white rounded-full mx-4 py-2`}>LOGIN</button>
                  </div>
                </div>
              </Formsy>

            </div>
          )
          : <LoadIcon /> }
      </>
    // )}
    // </UserProfileContextConsumer>
    );
  }
}

UserWebLoginForm.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default withRouter(withAuth(UserWebLoginForm));
